"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmptyString = _interopRequireDefault(require("../object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../object/isNil"));

var _isNumber = _interopRequireDefault(require("../numbers/isNumber"));

var _appendQueryParams = _interopRequireDefault(require("../url/appendQueryParams"));

var _media = require("../../constants/media");

/**
 * Create a URL to get a media variant.
 * @param {string} serverId
 * @param {VIDEO_TRANSFORM_TYPE} videoTransformType
 * @param {MediaVariant} mediaVariant
 * @returns {string} URL to the media variant API endpoint
 */
var createMediaVariantUrl = function createMediaVariantUrl(serverId, videoTransformType, mediaVariant) {
  if ((0, _isEmptyString["default"])(serverId) || (0, _isNil["default"])(videoTransformType) || (0, _isEmptyString["default"])(mediaVariant)) {
    throw new Error('Missing input data for media variant URL');
  }

  var chunkIndex = mediaVariant.chunkIndex,
      chunkSize = mediaVariant.chunkSize,
      height = mediaVariant.height,
      keyframeInterval = mediaVariant.keyframeInterval,
      width = mediaVariant.width; // Server expects "w" and "h" for dimensions so we need to translate the model.

  var baseUrl = "/api/v1/media/".concat(serverId, "/file");
  var variantData = {
    videoTransformType: videoTransformType
  };

  if ((0, _isNumber["default"])(chunkIndex) || chunkIndex === _media.CHUNK_INDEX_TOKEN) {
    Object.assign(variantData, {
      chunkIndex: chunkIndex
    });
  } else if (videoTransformType === _media.VIDEO_TRANSFORM_TYPE.CHUNK) {
    throw new Error('Missing chunk index for media variant URL');
  }

  if ((0, _isNumber["default"])(chunkSize)) {
    Object.assign(variantData, {
      chunkSize: chunkSize
    });
  } else if (videoTransformType === _media.VIDEO_TRANSFORM_TYPE.CHUNK) {
    throw new Error('Missing chunk size for media variant URL');
  }

  if ((0, _isNumber["default"])(height)) {
    Object.assign(variantData, {
      h: height
    });
  }

  if ((0, _isNumber["default"])(keyframeInterval)) {
    Object.assign(variantData, {
      keyframeInterval: keyframeInterval
    });
  } else if (videoTransformType === _media.VIDEO_TRANSFORM_TYPE.CHUNK || videoTransformType === _media.VIDEO_TRANSFORM_TYPE.TRANSCODE) {
    throw new Error('Missing keyframe interval for media variant URL');
  }

  if ((0, _isNumber["default"])(width)) {
    Object.assign(variantData, {
      w: width
    });
  }

  return (0, _appendQueryParams["default"])(baseUrl, variantData);
};

var _default = createMediaVariantUrl;
exports["default"] = _default;